export default "__VITE_ASSET__8ujx_HUb__"